import * as React from 'react'
import { FORM_CONTROL_CLASS } from '@/components/ui/form-control-styles'
import { cn } from '@/lib/utils'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-[80px] w-full rounded-md border px-3 py-2 ring-offset-white placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
        FORM_CONTROL_CLASS,
        className
      )}
      {...props}
    />
  )
)
Textarea.displayName = 'Textarea'

export { Textarea }
